<app-page-loading-bar></app-page-loading-bar>
<router-outlet></router-outlet>
<app-notifications-container></app-notifications-container>
<ng-container #confirmationsContainer></ng-container>
<ng-container #modalsContainer></ng-container>